import React, { Component } from 'react'
import TimeTable from '../components/Dienstregeling/TimeTable'
import Detail from '../components/Dienstregeling/Detail'
import dynamicPortal from '../utils/dynamicPortal';
import Disruptions from '../components/Dienstregeling/Disruptions';

export class DienstregelingPortal extends Component {
  render() {
    return dynamicPortal.load('.js-react-dienstregeling', (config) => (
      <React.Fragment>
        <Disruptions config={config} />
        <Detail config={config} />
        <TimeTable config={config} />
      </React.Fragment>
    ))
  }
}

export default DienstregelingPortal



// WEBPACK FOOTER //
// ./src/portals/DienstregelingPortal.js